import TableReportHelper from "report/helper";
import Trator from "./trator.jpeg";
import TratorIosBase64 from "./tratorIosBase64";

export default async function DCorIndicadorReportSummary( // pdf da visita ou pdf do laudo
    indicador,
    visita,
    tipoName,
    params,
    chartCallBack = null,
    unit = "%",
    fieldMediaConformidade = "conformidade",
    metaShow,
    showMeta = true,
    additionalColumn,
    secondChartCallBack = null
) {
    const h = new TableReportHelper(visita.data);

    const IndicadorClass = indicador.constructor;
    const apontamentos = visita.getApontamentosByIndicador(indicador, tipoName);

    const hasData = Array.isArray(apontamentos)
        && apontamentos.some((apontamento) => Array.isArray(apontamento?.coletas) && apontamento.coletas.length > 0);

    if (!hasData) {
        return null;
    }

    const toSafeNumber = (value) => {
        const parsed = parseFloat(value);
        return Number.isFinite(parsed) ? parsed : 0;
    };

    const isIOS = typeof window !== "undefined" && window?.cordova?.platformId === "ios";

    let averageConformidade = indicador.getAverage(visita, fieldMediaConformidade, tipoName);

    let averageConformidadeEsquerda = toSafeNumber(indicador.getAverage(visita, "conformeEsquerda", tipoName));
    let averageConformidadeCentro = toSafeNumber(indicador.getAverage(visita, "conformeCentro", tipoName));
    let averageConformidadeDireita = toSafeNumber(indicador.getAverage(visita, "conformeDireita", tipoName));

    const statusEsquerda = IndicadorClass.getConformidadeStatus(
        averageConformidadeEsquerda,
        params.meta,
        null,
        visita.cliente,
        indicador.type,
        tipoName
    );
    const statusCentro = IndicadorClass.getConformidadeStatus(
        averageConformidadeCentro,
        params.meta,
        null,
        visita.cliente,
        indicador.type,
        tipoName
    );
    const statusDireita = IndicadorClass.getConformidadeStatus(
        averageConformidadeDireita,
        params.meta,
        null,
        visita.cliente,
        indicador.type,
        tipoName
    );

    averageConformidade = toSafeNumber(averageConformidade);

    if (averageConformidade) {
        averageConformidade = averageConformidade.toFixed(3);
    }
    if (averageConformidade !== undefined) {
        function blobToBase64(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        }

        async function convertImageToBase64(url) {
            try {
                const response = await fetch(url);
                const blob = await response.blob();
                return await blobToBase64(blob);
            } catch (fetchError) {
                // Fallback for iOS WebView where fetch() can fail for local bundled assets.
                return await new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    xhr.open("GET", url, true);
                    xhr.responseType = "blob";

                    xhr.onload = async () => {
                        try {
                            if (xhr.status >= 200 && xhr.status < 400) {
                                resolve(await blobToBase64(xhr.response));
                            } else {
                                reject(new Error(`XHR status ${xhr.status}`));
                            }
                        } catch (error) {
                            reject(error);
                        }
                    };

                    xhr.onerror = () => reject(fetchError);
                    xhr.send();
                });
            }
        }

        let tratorToBase64 = null;

        if (isIOS) {
            try {
                tratorToBase64 = TratorIosBase64;
            } catch (error) {
                // No visual warning in the report; when conversion fails, just omit the image.
                console.warn("DCor summary image conversion failed on iOS", error);
            }
        } else {
            try {
                tratorToBase64 = await convertImageToBase64(Trator);
            } catch (error) {
                // Keep report generation running even if image conversion fails.
                console.warn("DCor summary image conversion failed", error);
            }
        }

        const content = [];
        const arrowEsquerda = [];
        const arrowCentro = [];
        const arrowDireita = [];

        if (statusEsquerda === "Ótimo") {
            arrowEsquerda.push(h.hyphen());
        } else if (averageConformidadeEsquerda < parseFloat(params.meta)) {
            arrowEsquerda.push(h.arrowDown(statusEsquerda));
        } else if (averageConformidadeEsquerda > parseFloat(params.meta)) {
            arrowEsquerda.push(h.arrowUp(statusEsquerda));
        }

        if (statusCentro === "Ótimo") {
            arrowCentro.push(h.hyphen());
        } else if (averageConformidadeCentro < parseFloat(params.meta)) {
            arrowCentro.push(h.arrowDown(statusCentro));
        } else if (averageConformidadeCentro > parseFloat(params.meta)) {
            arrowCentro.push(h.arrowUp(statusCentro));
        }

        if (statusDireita === "Ótimo") {
            arrowDireita.push(h.hyphen());
        } else if (averageConformidadeDireita < parseFloat(params.meta)) {
            arrowDireita.push(h.arrowDown(statusDireita));
        } else if (averageConformidadeDireita > parseFloat(params.meta)) {
            arrowDireita.push(h.arrowUp(statusDireita));
        }

        const headerRows = [];

        if (tratorToBase64) {
            headerRows.push(
                h.row([
                    h.panel(
                        [
                            {
                                image: tratorToBase64,
                                width: 150,
                            },
                        ],
                        { widths: ["*"], alignment: "center" }
                    ),
                ])
            );
        }

        content.push(
            h.panel(
                [
                    ...headerRows,
                    h.row([
                        h.panel(
                            [
                                h.panel([
                                    h.row([
                                        h.panel(
                                            [
                                                h.row([h.text("Esquerda", { alignment: "center" })]),
                                                h.row([
                                                    h.text(`${averageConformidadeEsquerda.toFixed(3)}%`, {
                                                        alignment: "center",
                                                    }),
                                                ]),
                                            ],
                                            { fillColor: IndicadorClass.getColorStatus(statusEsquerda) }
                                        ),
                                    ]),
                                    h.row([
                                        h.panel([h.row([arrowEsquerda]), h.row([h.empty()])], { alignment: "center" }),
                                    ]),
                                ]),
                                h.panel([
                                    h.row([
                                        h.panel(
                                            [
                                                h.row([h.text("Centro", { alignment: "center" })]),
                                                h.row([
                                                    h.text(`${averageConformidadeCentro.toFixed(3)}%`, {
                                                        alignment: "center",
                                                    }),
                                                ]),
                                            ],
                                            { fillColor: IndicadorClass.getColorStatus(statusCentro) }
                                        ),
                                    ]),
                                    h.row([
                                        h.panel([h.row([arrowCentro]), h.row([h.empty()])], { alignment: "center" }),
                                    ]),
                                ]),
                                h.panel([
                                    h.row([
                                        h.panel(
                                            [
                                                h.row([h.text("Direita", { alignment: "center" })]),
                                                h.row([
                                                    h.text(`${averageConformidadeDireita.toFixed(3)}%`, {
                                                        alignment: "center",
                                                    }),
                                                ]),
                                            ],
                                            { fillColor: IndicadorClass.getColorStatus(statusDireita) }
                                        ),
                                    ]),
                                    h.row([
                                        h.panel([h.row([arrowDireita]), h.row([h.empty()])], { alignment: "center" }),
                                    ]),
                                ]),
                            ],
                            { widths: ["*", "*", "*"] }
                        ),
                    ]),
                ],
                { widths: ["*"], colSpan: 2 }
            )
        );
        return content;
    } else {
        return null;
    }
}
